//@ts-nocheck
/* eslint-disable react/forbid-prop-types */
import React from 'react'
import T from 'prop-types'
import _ from 'lodash'
import FloorsDropDown from '../FloorsDropDown/FloorsDropDown'
import SwitchFloorButton from '../SwitchFloorButton/SwitchFloorButton'
import LocationPicker from '../LocationPicker/LocationPicker'
import AppBar from '../AppBar/AppBar'

import SearchBox from '../SearchBox/SearchBox'
import ProfileMenu from '../ProfileMenu/ProfileMenu'

import withFeatures from '../../hoc/withFeatures'
import { withFloorMap } from '@wework/react-floormap'
import compose from 'utils/compose'
import { Button } from 'semantic-ui-react'
import { Text, Icon, Grid } from '@wework/dieter-ui'
import ViewOptionsBarContent from '../Content/ViewOptionsBarContent'
import { AboutIcon, Download, FilterIcon } from '../Icons'
import { withSnackbar } from 'hoc/SnackBarProvider'
import { useSidebar } from '../../hoc/withSidebar'
import Row from '../Common/Row'
import IMTheme from '../../style/IMTheme'

const Header = ({
  currentBuilding,
  currentFloor,
  onChangeLocation,
  onChangeFloor,
  loading,
  buildingError,
  floorError,
  openFloorsDropDown,
  handleFloorsDropDownToggle,
  handleFloorsDropDownClose,
  openLocationsDropDown,
  handleLocationsDropDownState,
  FloorsDropDownEnable,
  borderBottom,
  profileMenuProps,
  spaces,
  onSearchChange,
  searchText,
  isFeatureEnabled,
  allowUnMappedBuilding,
  currentTab,
  emitUserEvent,
  setLoading,
  floorList,
  viewOptions,
  handleOnViewOptionsChange,
  onTabChange,
  onMultiSelectClick,
  multipleSelected,
  snackBars,
}) => {
  const { openSideBar } = useSidebar()
  const LocationPickerJSX = isFeatureEnabled('locationList') ? (
    <div
      style={{
        marginLeft: IMTheme.spacing[3],
      }}
    >
      <LocationPicker
        onChangeLocation={onChangeLocation}
        currentBuildingId={
          _.get(currentBuilding, 'systemUUID') || _.get(currentBuilding, 'uuid')
        }
        currentLocationName={_.get(currentBuilding, 'name')}
        disabled={loading && !buildingError && !floorError}
        open={openLocationsDropDown}
        handleOpen={handleLocationsDropDownState}
        allowUnMappedBuilding={allowUnMappedBuilding}
      />
    </div>
  ) : null

  const FloorsDropDownJSX = FloorsDropDownEnable ? (
    <FloorsDropDown
      currentFloor={currentFloor}
      floors={floorList}
      onSelect={onChangeFloor}
      disabled={loading && !floorError}
      open={openFloorsDropDown}
      handleClose={handleFloorsDropDownClose}
      handleToggle={handleFloorsDropDownToggle}
    />
  ) : (
    <></>
  )

  const SwitchFloorButtonsJSX = (
    <SwitchFloorButton
      disabled={loading && !floorError}
      floors={floorList}
      currentFloor={currentFloor}
      onChangeFloor={onChangeFloor}
    />
  )

  let BuildingInfoJSX = <></>
  if (currentBuilding.isMapped || allowUnMappedBuilding) {
    if (
      !buildingError ||
      (currentBuilding && allowUnMappedBuilding && buildingError)
    ) {
      BuildingInfoJSX = (
        <Button
          onClick={() => openSideBar('BuildingInfo')}
          basic
          disabled={
            buildingError && allowUnMappedBuilding
              ? false
              : loading && !floorError
          }
          icon={<AboutIcon />}
          style={{
            width: 40,
            height: 40,
            marginLeft: IMTheme.spacing[1],
            marginRight: IMTheme.spacing[1],
          }}
        />
      )
    }
  }

  return (
    <AppBar borderBottom={borderBottom}>
      <Grid stretched>
        <Grid.Row stretched>
          <Row>
            <Row justify="flex-start">
              {LocationPickerJSX}
              {FloorsDropDownJSX}
              {SwitchFloorButtonsJSX}
              {BuildingInfoJSX}
              <Button
                disabled={loading && !buildingError && !floorError}
                basic
                onClick={() => openSideBar('DownloadPlans')}
                icon={<Download />}
                style={{
                  width: 40,
                  height: 40,
                  marginLeft: IMTheme.spacing[1],
                  marginRight: IMTheme.spacing[1],
                }}
              />
              <ViewOptionsBarContent
                viewOptions={viewOptions}
                disabled={loading && !buildingError && !floorError}
                onValueChange={handleOnViewOptionsChange}
              />
              <Button
                size="medium"
                active={multipleSelected}
                basic
                onClick={() => {
                  onMultiSelectClick()
                  snackBars.addAlert({
                    text: '👆 Select multiple spaces on the map to start.',
                    variant: 'default',
                  })
                }}
                style={{
                  textTransform: 'inherit',
                  borderRadius: 36,
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: IMTheme.spacing[1],
                }}
                disabled={loading && !buildingError && !floorError}
              >
                <Text size="small" primary={multipleSelected}>
                  Multi-select
                </Text>

                {multipleSelected && (
                  <Icon
                    name="close"
                    style={{
                      marginLeft: IMTheme.spacing[4],
                      marginRight: 0,
                      color: IMTheme.colors.primary,
                    }}
                  />
                )}
              </Button>
            </Row>
            <Row
              style={{
                marginLeft: 'auto',
              }}
              justify="flex-end"
            >
              <SearchBox
                onChange={onSearchChange}
                placeholder="Search inventory"
                searchText={searchText}
                disabled={loading && !floorError}
              />
              <Button
                basic
                active={currentTab === 'filters'}
                style={{
                  width: 40,
                  height: 40,
                  marginLeft: IMTheme.spacing[2],
                  marginRight: IMTheme.spacing[1],
                }}
                onClick={() => onTabChange('filters')}
                icon={
                  <FilterIcon
                    color={
                      currentTab === 'filters'
                        ? IMTheme.colors.primary
                        : IMTheme.colors.darkGrey
                    }
                  />
                }
              />
              <div
                style={{
                  marginLeft: IMTheme.spacing[1],
                  marginRight: IMTheme.spacing[4],
                }}
              >
                <ProfileMenu {...profileMenuProps} />
              </div>
            </Row>
          </Row>
        </Grid.Row>
      </Grid>
    </AppBar>
  )
}

Header.propTypes = {
  FloorsDropDownEnable: T.bool,
  currentBuilding: T.any,
  currentFloor: T.any,
  onChangeLocation: T.func,
  onChangeFloor: T.func,
  loading: T.bool,
  buildingError: T.bool,
  floorError: T.bool,
  openFloorsDropDown: T.bool,
  handleFloorsDropDownToggle: T.func,
  handleFloorsDropDownClose: T.func,
  openLocationsDropDown: T.bool,
  handleLocationsDropDownState: T.func,
  tabControlProps: T.any,
  borderBottom: T.bool,
  profileMenuProps: T.any,
  spaces: T.any,
  onSearchChange: T.func,
  searchText: T.string,
  isFeatureEnabled: T.func,
  allowUnMappedBuilding: T.bool,
  emitUserEvent: T.func,
  setLoading: T.func,
  floorList: T.array,
}

Header.defaultProps = {
  FloorsDropDownEnable: true,
  currentBuilding: null,
  currentFloor: null,
  onChangeLocation: () => {},
  onChangeFloor: () => {},
  loading: true,
  buildingError: false,
  floorError: false,
  openFloorsDropDown: false,
  handleFloorsDropDownToggle: () => {},
  handleFloorsDropDownClose: () => {},
  openLocationsDropDown: false,
  handleLocationsDropDownState: () => {},
  tabControlProps: '',
  borderBottom: false,
  profileMenuProps: '',
  spaces: '',
  onSearchChange: () => {},
  searchText: '',
  isFeatureEnabled: () => {},
  allowUnMappedBuilding: false,
  emitUserEvent: () => {},
  setLoading: () => {},
  floorList: [],
}

export default compose(withFloorMap(), withFeatures())(withSnackbar(Header))
